module.exports = __webpack_public_path__ + "static/media/final_background_mobile.34f5ee1e.png";